import axios from "axios";

export const uploadImage = payload => {
  return axios.post(
    `${process.env.VUE_APP_API_URL}/editor/upload-image`,
    payload
  );
};
